export const SET_ACTIVE_MODULE = 'SET_ACTIVE_MODULE'

export const AUTOLOGIN_ROUTE = 'autologin'
